module.exports = __webpack_public_path__ + "d68fb115f75086c11c9d839f83fe8443.png";